export default "__VITE_ASSET__ec508bcb__"